import URL from "core/resources/urls";
import http from "infra/http";
import { useMutation } from "react-query";

export function useTermOfUse() {
  return useMutation("v1", () => {
    return http.post(URL.TERMO_USO.ACEITAR, { sistema: 2 });
  });
}
